import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api/auth';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 로컬 스토리지에서 사용자 정보 복원
    const savedUser = localStorage.getItem('user');
    const savedToken = localStorage.getItem('accessToken');
    
    if (savedUser && savedToken) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  // 토큰 만료 시 자동 로그아웃 이벤트 감지
  useEffect(() => {
    const handleAuthLogout = (event) => {
      console.log('Auth logout event received:', event.detail);
      setUser(null);
    };

    window.addEventListener('auth:logout', handleAuthLogout);
    
    return () => {
      window.removeEventListener('auth:logout', handleAuthLogout);
    };
  }, []);

  const login = async (username, password) => {
    try {
      const response = await authAPI.login({ username, password });
      
      // 토큰과 사용자 정보 저장
      localStorage.setItem('accessToken', response.accessToken);
      localStorage.setItem('user', JSON.stringify({
        userId: response.userId,
        username: response.username,
        email: response.email,
        role: response.role,
      }));

      setUser({
        userId: response.userId,
        username: response.username,
        email: response.email,
        role: response.role,
      });

      return response;
    } catch (error) {
      throw error;
    }
  };

  const signup = async (username, password, email = null) => {
    try {
      const response = await authAPI.signup({ username, password, email });
      
      // 토큰과 사용자 정보 저장
      localStorage.setItem('accessToken', response.accessToken);
      localStorage.setItem('user', JSON.stringify({
        userId: response.userId,
        username: response.username,
        email: response.email,
        role: response.role,
      }));

      setUser({
        userId: response.userId,
        username: response.username,
        email: response.email,
        role: response.role,
      });

      return response;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    signup,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

